import { DataItemType, FormControlType } from "../../../../form/schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
import pc from './components/pc-dropdown.vue';
import mobile from './components/mobile-dropdown.vue';
export const info = {
    title: "下拉单选框",
    title_i18n: "{\"zh\": \"下拉单选框\", \"en\": \"Dropdown\"}",
    type: "drop-down",
    icon: "h-icon-all-a-Drop-downsingle-o",
    dataItemType: DataItemType.Dropdown,
    formControllerType: FormControlType.Dropdown,
    group: "基础控件",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
        pc,
        mobile
    },
};
